"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const ScrollIndicatorContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ScrollIndicatorContainer",
  class: "pl-s1gaelix"
});
const NavigationItem = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavigationItem",
  class: "pl-nzn4cn3",
  vars: {
    "nzn4cn3-0": [({
      active
    }) => active ? '2.926rem' : '1.672rem'],
    "nzn4cn3-1": [({
      active
    }) => active ? `${_intents.default.ux.box.foregroundColor}` : `${_intents.default.ux.boxLowContrast.backgroundColor}`]
  }
});

/**
 * ScrollIndicator Component.
 *
 * @param {Object} props React props
 * @param {Object} props.element Attach Scrollable Container Ref
 * @param {Object} props.elementArr Mapper for Each Item Array
 * @returns {React.ReactElement} ScrollIndicator Component
 * @public
 */

function ScrollIndicator({
  element,
  elementArr
}) {
  const [scrollProgress, setScrollProgress] = (0, _react.useState)(0);
  const converter = 100; // Calc Converter
  const isRTL = (0, _patternLibraryUtils.useIsRTL)();
  const scrollListener = () => {
    if (!element.current) {
      return null;
    }
    const container = element.current; // Current ref selected element
    const containerScroll = container.scrollLeft; // Scroll Distance Snap End Point
    const containerWidth = container.scrollWidth - container.clientWidth; // Max Slider Width

    if (containerScroll === 0) {
      return setScrollProgress(0);
    } else if (containerScroll > containerWidth) {
      return setScrollProgress(1);
    }
    if (isRTL) {
      setScrollProgress(1 - containerScroll / containerWidth * converter);
    } else {
      setScrollProgress(containerScroll / containerWidth * converter);
    }
  };
  (0, _react.useEffect)(() => {
    element.current.addEventListener('scroll', scrollListener);
    return () => element.current && element.current.removeEventListener('scroll', scrollListener); // Remove Scroll Listener
  });
  const indicator = () => {
    const activeNavValue = scrollProgress * elementArr / converter;
    return [...Array(elementArr).keys()].map(index => /*#__PURE__*/_react.default.createElement(NavigationItem, {
      key: index,
      active: activeNavValue >= index && activeNavValue <= index + 1
    }));
  };
  return /*#__PURE__*/_react.default.createElement(ScrollIndicatorContainer, {
    "data-cy": "scroll-indicator"
  }, indicator());
}
var _default = exports.default = ScrollIndicator;
ScrollIndicator.propTypes = {
  element: _propTypes.default.object.isRequired,
  elementArr: _propTypes.default.number.isRequired
};